import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { FaMagnifyingGlass } from "react-icons/fa6";
import TableUI from "../../components/Table";
import { TextInputForm, DropDownUI } from "../../components/Forms";
import { Buttons } from "../../../src/components/Buttons";
import { ClickButton } from "../../components/ClickButton";
import { useNavigate } from "react-router-dom";
import MobileView from "../../components/MobileView";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { IoMdCloseCircle } from "react-icons/io";
import { IoFilter } from "react-icons/io5";
import API_DOMAIN from "../../config/config";
import { useMediaQuery } from "react-responsive";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import LoadingOverlay from "../../components/LoadingOverlay";
const UserTablehead = [
  "No",
  "நகை அடகு வைத்த தேதி",
  "நகை மீட்பு தேதி",
  "ரசீது எண்",
  "வாடிக்கையாளர் பெயர்",
  "கைபேசி எண்",
  "செயல்",
];

const User = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    CustomerName: "",
    ReceiptNo: "",
  });
  console.log("formData", formData);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleLoad = () => {
    setFormData({
      CustomerName: "",
      ReceiptNo: "",
    });
  };
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const itemsPerPage = 10;

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnrecovery.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: searchText,
          limit: itemsPerPage,
          offset: (page - 1) * itemsPerPage,
        }),
      });

      const responseData = await response.json();
      console.log("responseData", responseData);

      if (responseData.head.code === 200) {
        let sortedData = responseData.body.pawn_recovery.map((user) => ({
          ...user,
          jewel_product: JSON.parse(user.jewel_product || "[]"), // Ensure jewel_product is an array
        }));

        if (formData.CustomerName) {
          console.log("formData.CustomerName", formData.CustomerName);
          sortedData = sortedData.filter(
            (user) => user.customer_name === formData.CustomerName
          );
        }

        if (formData.ReceiptNo) {
          console.log("formData.ReceiptNo", formData.ReceiptNo);
          sortedData = sortedData.filter(
            (user) => user.recipt_no === formData.ReceiptNo
          );
        }
        setUserData(sortedData);
        setTotalRecords(responseData.body.total_records);
        setLoading(false);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, [searchText, formData, currentPage, itemsPerPage]);
  const handleSearch = (value) => {
    console.log("Search value:", value);
    setSearchText(value);
    setCurrentPage(1);
  };

  const nextPage = () => {
    if (currentPage < Math.ceil(totalRecords / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg="7" md="6" xs="6">
            <div className="page-nav py-3">
              <span class="nav-list">நகை மீட்பு </span>
            </div>
          </Col>
          <Col lg="5" md="6" xs="6" className="align-self-center text-end">
            <ClickButton
              label={<>Add New</>}
              onClick={() => navigate("/console/master/jewelrecovery/create")}
            ></ClickButton>
          </Col>

          <Col lg="3" md="12" xs="12" className="py-1">
            <TextInputForm
              placeholder={"பெயர் ,மொபைல் எண்."}
              onChange={(e) => handleSearch(e.target.value)}
              prefix_icon={<FaMagnifyingGlass />}
            >
              {" "}
            </TextInputForm>
          </Col>
          {/* <Col lg={6} md={12} xs={12} className="py-2 text-end">
            <span>
              <Button onClick={handleShow} className="filter my-2">
                <span className="me-2">
                  <IoFilter />
                </span>
                Filter
              </Button>

              <Button onClick={handleLoad} className="filter mx-2">
                <span className="me-2">
                  <IoFilter />
                </span>
                Undo Filter
              </Button>
            </span>
            <Offcanvas
              show={show}
              onHide={handleClose}
              placement="end"
              backdrop={true}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Title of Our</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Button onClick={handleLoad} className="filter mx-2">
                  <span className="me-2">
                    <IoFilter />
                  </span>
                  Undo Filter
                </Button>
                <div className="text-end">
                  <Button onClick={handleClose}>
                    <IoMdCloseCircle className="close-btn" />
                  </Button>
                </div>
                <div className="mt-3">
                  <Row>
                    <Col lg="12" md="12" xs="12" className="py-3">
                      <DropDownUI
                        optionlist={userData.map((user) => ({
                          value: user.recipt_no,
                          label: user.recipt_no,
                        }))}
                        placeholder="ரசீது எண்"
                        labelname="ரசீது எண்"
                        name="ReceiptNo"
                        value={formData.ReceiptNo}
                        onChange={(updatedFormData) =>
                          setFormData({
                            ...formData,
                            ReceiptNo: updatedFormData.ReceiptNo,
                          })
                        }
                      />
                    </Col>
                    <Col lg="12" md="12" xs="12" className="py-3">
                      <DropDownUI
                        optionlist={userData.map((user) => ({
                          value: user.customer_name,
                          label: user.customer_name,
                        }))}
                        labelname={"வாடிக்கையாளர் பெயர்"}
                        placeholder="வாடிக்கையாளர் பெயர்"
                        name="CustomerName"
                        value={formData.CustomerName}
                        onChange={(updatedFormData) =>
                          setFormData({
                            ...formData,
                            CustomerName: updatedFormData.CustomerName,
                          })
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </Col> */}
          <Col lg={3} md={12} xs={12} className="py-2"></Col>
          {loading ? (
            <LoadingOverlay isLoading={loading} />
          ) : (
            <>
              <Col lg="12" md="12" xs="12" className="px-0">
                <div className="py-1">

                  <div className="text-end">
                    <span className="mx-1">
                      Page {currentPage} of{" "}
                      {Math.ceil(totalRecords / itemsPerPage)}
                    </span>
                    <span className="mx-1">
                      <Buttons
                        lable={<MdChevronLeft />}
                        onClick={prevPage}
                        disabled={currentPage === 1}
                      />
                    </span>
                    <span className="mx-1">
                      <Buttons
                        lable={<MdChevronRight />}
                        onClick={nextPage}
                        disabled={
                          currentPage === Math.ceil(totalRecords / itemsPerPage)
                        }
                      />
                    </span>
                  </div>
                  <TableUI
                    headers={UserTablehead}
                    body={userData}
                    type="jewelRecovery"
                    pageview={"no"}
                    style={{ borderRadius: "5px" }}
                  />
                  <div className="text-end">
                    <span className="mx-1">
                      Page {currentPage} of{" "}
                      {Math.ceil(totalRecords / itemsPerPage)}
                    </span>
                    <span className="mx-1">
                      <Buttons
                        lable={<MdChevronLeft />}
                        onClick={prevPage}
                        disabled={currentPage === 1}
                      />
                    </span>
                    <span className="mx-1">
                      <Buttons
                        lable={<MdChevronRight />}
                        onClick={nextPage}
                        disabled={
                          currentPage === Math.ceil(totalRecords / itemsPerPage)
                        }
                      />
                    </span>
                  </div>
                </div>
              </Col>
            </>
          )}
          <Col lg={12} md={12} xs={12}></Col>
        </Row>
      </Container>
    </div>
  );
};

export default User;
